module.exports = __webpack_public_path__ + "assets-cabinet/img/accordeon-toggle.e50aa544.svg";